module.exports = __webpack_public_path__ + "static/media/reports.d419c2ba.svg";